// 取得簽名板權限
export default {
  methods: {
    getSignPadAuth () {
      console.log('getSignPadAuth')
      return new Promise((resolve, reject) => {
        const url = `${process.env.VUE_APP_CORE_URL}/api/Community/IsSignature`
        axios(url, {
          method: 'get',
          headers: {
            KingnetAuth: 'Cookies ' + this.$getCookie('comLoginToken').split('token=').pop()
          }
        }).then(res => {
          console.log(res)
          resolve(res.data.Data)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
